import { useZero } from "@rocicorp/zero/react";

/** The signed-in user's id, from the Zero connection — no network round trip. */
export function useCurrentUserId(): string {
  // ZeroSetup always constructs the client with the session's user id.
  return useZero().userID!;
}
